module.exports = __webpack_public_path__ + "img/BGMain4.f03eeff7.jpg";